import { createSlice } from '@reduxjs/toolkit';
import storage from 'services/utils/storage';

export const generalReducer = createSlice({
  name: 'general',
  initialState: {
    language: storage.getItem('language') || 'en-US',
    host: null
  },
  reducers: {
    /**
     * @name @login
     * @description login reducer to call login async API with axios instance
     * @requires ApiServices.get method, state and API payload
     **/
    setLanguage: (state, action) => {
      state.language = action.payload || 'en-US';
      storage.setItem('language', state.language);
    },
    /**
     * @name @setGeneralState
     * @description to save general info in general state
     * @requires state,action for payload, Note: action.payload must be a object
     **/
    setGeneralState: (state, action) => {
      Object.keys(action.payload).forEach(key => {
        state[key] = action.payload[key];
      });
    }
  }
});
export const { setLanguage, setGeneralState } = generalReducer.actions;
export const stopPropogation = ref => dispatch => {
  /**
   * hide on clicked outside of the element
   */
  return new Promise((resolve, reject) => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        return resolve(true);
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
};

export const selectShow = state => state.view;

export const selectLangauge = state => {
  return state.general.language;
};

export const getGeneralInfo = state => {
  return state.general;
};

export const getSpecificGeneralInfo = key => state => {
  return state.general[key];
};

export default generalReducer.reducer;
